import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class ShowSourceQueryParameterModel extends ApiModel {
  static get path() {
    return '/backend/show_source_query_parameters/{?id}';
  }

  @computed
  get sourceQueryPropertyName(): string {
    return this.get('name', '');
  }

  @computed
  get value(): string {
    return this.get('value', '');
  }

  @computed
  get sourceId(): id {
    return this.get('source.id');
  }
}
